import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Loader.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Loader.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {number} [size]
 */
export default class Loader extends Component {
  render() {
    const {
      size = 16
    } = this.props;
    return __h("svg", {
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      width: size,
      height: size,
      "class": util.shrink0 + " " + css.loader,
      fill: "currentColor",
      "aria-hidden": true
    }, __h("circle", {
      cx: "3",
      cy: "8",
      r: "2"
    }), __h("circle", {
      cx: "8",
      cy: "8",
      r: "2"
    }), __h("circle", {
      cx: "13",
      cy: "8",
      r: "2"
    }));
  }
}